import { TRIAL_FEATURES, type TrialFeature } from '@discover-frontend/components';
import { FUSION_TYPES } from '@discover-frontend/constants';

export const TRIAL_RESTRICTED_FUSION_SOURCES = Object.values(FUSION_TYPES);

const FUSION_SOURCE_TO_FEATURE: Record<
  (typeof FUSION_TYPES)[keyof typeof FUSION_TYPES],
  TrialFeature
> = {
  [FUSION_TYPES.GWI]: TRIAL_FEATURES.GWI,
  [FUSION_TYPES.MRI_SIMMONS]: TRIAL_FEATURES.MRI_SIMMONS,
  [FUSION_TYPES.TGI]: TRIAL_FEATURES.TGI,
  [FUSION_TYPES.WW_GWI_MED]: TRIAL_FEATURES.WW_GWI_MED,
};

export const isTrialRestrictedFusionSource = (
  source?: string | null
): source is (typeof TRIAL_RESTRICTED_FUSION_SOURCES)[number] =>
  Boolean(
    source &&
      (TRIAL_RESTRICTED_FUSION_SOURCES as readonly string[]).includes(source)
  );

export const getTrialFeatureForFusionSource = (
  source: string
): TrialFeature | undefined =>
  isTrialRestrictedFusionSource(source)
    ? FUSION_SOURCE_TO_FEATURE[source]
    : undefined;
